/**
 * Application feature flags and configuration
 * 
 * This file centralizes all feature flags and configuration settings.
 * Values are derived from environment variables where possible.
 */

/**
 * Feature flags to control functionality availability
 */
export const FEATURES = {
  /**
   * Controls whether unauthenticated users can access demo works
   * Set to false to disable all public demo functionality
   */
  PUBLIC_DEMO_WORKS: process.env.ENABLE_PUBLIC_DEMO === 'true',
};

/**
 * Configuration for demo works
 */
export const DEMO_CONFIG = {
  /**
   * Cache duration for demo work responses in seconds
   * 4 hours = 14400 seconds
   */
  CACHE_DURATION: 14400,
  
  /**
   * Optional pattern for demo work friendly IDs
   * Can be configured via environment variable
   */
  FRIENDLY_ID_PATTERN: process.env.DEMO_WORK_ID_PATTERN || null,
  
  /**
   * Function to check if a work ID matches demo pattern
   */
  isValidDemoId: (friendlyId: string): boolean => {
    // If no pattern is configured, rely solely on tags and public flag
    if (!DEMO_CONFIG.FRIENDLY_ID_PATTERN) return true;
    
    // Otherwise, match against the configured pattern
    const pattern = new RegExp(DEMO_CONFIG.FRIENDLY_ID_PATTERN);
    return pattern.test(friendlyId);
  },
};
